import React from 'react'

const EarlyCheckInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_4517_33657)'>
      <path
        d='M7.00004 9.91658C6.1931 9.91658 5.50525 9.63221 4.9365 9.06346C4.36775 8.49471 4.08337 7.80686 4.08337 6.99992C4.08337 6.19297 4.36775 5.50513 4.9365 4.93638C5.50525 4.36763 6.1931 4.08325 7.00004 4.08325C7.80699 4.08325 8.49483 4.36763 9.06358 4.93638C9.63233 5.50513 9.91671 6.19297 9.91671 6.99992C9.91671 7.80686 9.63233 8.49471 9.06358 9.06346C8.49483 9.63221 7.80699 9.91658 7.00004 9.91658ZM2.91671 7.58325H0.583374V6.41659H2.91671V7.58325ZM13.4167 7.58325H11.0834V6.41659H13.4167V7.58325ZM6.41671 2.91659V0.583252H7.58337V2.91659H6.41671ZM6.41671 13.4166V11.0833H7.58337V13.4166H6.41671ZM3.73337 4.52075L2.26046 3.10617L3.09171 2.24575L4.49171 3.70409L3.73337 4.52075ZM10.9084 11.7541L9.49379 10.2812L10.2667 9.47908L11.7396 10.8937L10.9084 11.7541ZM9.47921 3.73325L10.8938 2.26034L11.7542 3.09159L10.2959 4.49159L9.47921 3.73325ZM2.24587 10.9083L3.71879 9.49367L4.52087 10.2666L3.10629 11.7395L2.24587 10.9083Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_4517_33657'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default EarlyCheckInIcon
